export default __webpack_public_path__ + "static/media/home-search-store.afea17d3.jpg";